/**
 * Constantes da landing de marketing (/landing).
 * Sem CNPJ. URLs de loja só via env — nunca inventadas.
 */

export const LANDING_CONTACT_EMAIL = 'contato@appsaude.ia.br';
export const LANDING_CONTACT_ADDRESS = 'Atendimento em todo o Brasil';

export const LANDING_NAV_ITEMS = [
  { href: '#inicio', label: 'Início' },
  { href: '#sobre', label: 'Sobre o App' },
  { href: '#beneficios', label: 'Benefícios' },
  { href: '#como-funciona', label: 'Como funciona' },
] as const;

export const LANDING_STORES_COMING_SOON = 'Em breve no Google Play e na App Store';

type LandingStoreEnv = {
  VITE_PLAY_STORE_URL?: string;
  VITE_APP_STORE_URL?: string;
};

let hydratedStoreEnv: LandingStoreEnv = {};

/** Chamado no bootstrap com `import.meta.env` (evita import.meta neste módulo — Jest). */
export function hydrateLandingStoreEnv(env: LandingStoreEnv): void {
  hydratedStoreEnv = {
    VITE_PLAY_STORE_URL: env.VITE_PLAY_STORE_URL,
    VITE_APP_STORE_URL: env.VITE_APP_STORE_URL,
  };
}

function readStoreUrl(key: keyof LandingStoreEnv): string {
  const fromHydrated = hydratedStoreEnv[key];
  if (typeof fromHydrated === 'string' && fromHydrated.trim()) {
    return fromHydrated.trim();
  }

  const proc = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process;
  const fromProcess = proc?.env?.[key];
  if (typeof fromProcess === 'string' && fromProcess.trim()) {
    return fromProcess.trim();
  }

  return '';
}

export function getPlayStoreUrl(): string {
  return readStoreUrl('VITE_PLAY_STORE_URL');
}

export function getAppStoreUrl(): string {
  return readStoreUrl('VITE_APP_STORE_URL');
}
